// Dependencies
import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { Helpers } from '../utils'

// Types
import { Types, Containers } from '../types'

// Hooks
import { useDebug } from '../hooks'

// Components
import { Availability, Price, QuantitySelect, AddToCartButton, StyledButton, StyledHomecreditButton } from '../components/Product'
import Icon from '../components/Icon'

const AddToCartArea = ({ selectedVariation, setState, config, onAddToCart, translations, ...parentProduct }: any) => {
    useDebug(`AddToCartArea [${parentProduct.name}]`)

    React.useEffect(() => {
        
        if ( ! config.compatibility.includes('ti-woocommerce-wishlist') || ! parentProduct.available ) {
            return;
        }

        const wishlistButton = document.querySelector('.tinvwl_add_to_wishlist_button');

        try {
            if ( wishlistButton ) {

                wishlistButton.setAttribute('data-tinv-wl-product', parentProduct.id);
                wishlistButton.setAttribute('data-tinv-wl-productvariation', selectedVariation.id);

                // wishlistButton.classList.toggle('tinvwl-product-already-on-wishlist', alreadyInWishlist)
                // wishlistButton.classList.toggle('tinvwl-product-in-list', alreadyInWishlist)
            }
        } catch (e) {
            console.log(e)
        }

    
    }, [selectedVariation?.id, parentProduct?.id, config.compatibility]);

    const product: any = React.useMemo(() => {
        //if ( _.isEmpty(parentProduct) ) return null;
        
        if ( parentProduct.type === 'variable' )  {
            if ( _.isEmpty({...selectedVariation}) ) return null;
            if ( _.isEmpty({...parentProduct.options.available}) ) return null;
            const { quantity: {selected}, ...parent } = parentProduct;
            const { quantity: {min, max}, ...variation } = _.merge(selectedVariation, config.general.quantity);
            // quantity: {...active.quantity, selected: parentProduct.quantity}
            return {...parentProduct, ...selectedVariation, quantity: {min, max, selected}};
        }
        return parentProduct;
    }, [selectedVariation, parentProduct])

    if ( ! product ) { 
        return null;
    }
    
    //if ( ! product.available || ! parentProduct?.available ) return null;
    if ( ! product.purchasable || ! parentProduct.purchasable ) return null; 

    const priceArgs = {
        quantity: product.quantity.selected,
        displayMode: _.isBoolean(product?.taxable) ? (product?.taxable ? 'include' : 'exclude') : null ?? config.general.tax.displayMode,
        taxClass: product?.taxClass ?? config.general.tax.default,
        taxRates: config.general.tax.rates,
        precision: Math.abs(config.general.roundingPrecision),
        isOnSale: product.price?.sale && product.price.sale < product.price.regular
    }

    return ( 
        <AddToCartWrapper>

            <MetaWrapper>
                <Availability {...{ product, ...{ config, translations } }} />
                {/* NOTE: HOTFIX: product?.price?.regular causes TypeError */}
                {product?.price?.regular && <Price pricePerUnitThreshold={1} {...{ ...product, quantity: product.quantity.selected, ...{ config, translations } }} />}
            </MetaWrapper>

            { (product.purchasable && product.available) &&
                <ActionsWrapper>
                    <QuantitySelect
                    // NOTE: active || null if variable/variation
                        quantity={product.quantity}
                        onChange={(newQuantity: number) => setState('quantity', (prevQuantity: any) => ({...prevQuantity, selected: newQuantity}))}
                    />
                    <AddToCartButton
                        onClick={() => onAddToCart()}
                        translations={translations}
                    />
                    {
                        config?.compatibility?.includes('woo-homecredit') && 
                        <HomeCreditButton  price={ Helpers.getPrice({price: priceArgs.isOnSale ? product?.price.sale : product?.price.regular, ...priceArgs}) || 0 } {...{ config, translations }}  />
                    }
                </ActionsWrapper>
            }

        </AddToCartWrapper>
    )
}

const HomeCreditButton = ({price, ...props}: any) => (
    <StyledHomecreditButton as="a" target="_blank" href={`/?wc-api=hccalc&price=${(price * (10 ** props.config.general.decimals)).toFixed(0)}`} >
        <Icon id={`logoHomecredit`} {...props} />
    </StyledHomecreditButton>
)

// const WishlistButton = ({product, ...props}: any) => ()

const AddToCartWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    
    // NOTE: Dirty but usable for now
    ${({ theme: { general } }) => Helpers.clamp('padding', general.wrapper.padding.inline / 1.5, general.wrapper.padding.inline, 2.5)}
    ${({ theme: { general } }) => Helpers.clamp('padding-top', general.wrapper.padding.block / 1.5, general.wrapper.padding.block, 2.5)}
    ${({ theme: { general } }) => Helpers.clamp('padding-bottom', general.wrapper.padding.inline / 1.5, general.wrapper.padding.inline, 2.5)}
    background-color: ${({ theme: { components } }) => components.addToCart.background};
    border-radius: ${({ theme: { components } }) => components.addToCart.borderRadius}em;
    transition: ${({ theme: { general } }) => `all ${general.transition.duration} ${general.transition.timingFunction}`};
    
    outline: none;

    // TODO: Mixin
    /* &:not(:hover):focus-within {
        box-shadow: 0 0 0 .25em rgba(0, 0, 0, .15) !important;
    } */
    
`

const MetaWrapper = styled.div`
    display: flex;
    position: relative;
    align-items: flex-end;
    justify-content: space-between;
`
const ActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    column-gap: 1em;
    height: 3.25em;
    margin-top: ${1 + (2 * 0.5)}em; // line-height + spacing-top + spacing-bottom
`

export default AddToCartArea;
